"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.withTracker = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _client = require("../html/client");

var withTracker = function withTracker(WrappedComponent, options) {
  if (options === void 0) {
    options = {};
  }

  var trackPage = function trackPage(path, title) {
    if ((0, _client.isClient)()) {
      if (typeof window.gtag === "function") {
        window.gtag("config", window.GA_TRACKING_ID, {
          page_location: window.location.href,
          page_path: window.location.pathname,
          // 'page_path': path,
          page_title: title
        });
      }
    }
  };

  var HOC =
  /*#__PURE__*/
  function (_Component) {
    (0, _inheritsLoose2.default)(HOC, _Component);

    function HOC() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = HOC.prototype;

    _proto.componentDidMount = function componentDidMount() {
      // const page = this.props.location.pathname + this.props.location.search;
      var page = this.props.path;
      trackPage(page, this.props.title);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var currentPage = prevProps.path; // prevProps.location.pathname + prevProps.location.search;

      var nextPage = this.props.path; // this.props.location.pathname + this.props.location.search;

      if (currentPage !== nextPage) {
        trackPage(nextPage, this.props.title);
      }
    };

    _proto.render = function render() {
      return _react.default.createElement(WrappedComponent, this.props);
    };

    return HOC;
  }(_react.Component);

  return HOC;
};

exports.withTracker = withTracker;